<template>
  
</template>

<script setup lang="ts">
import { snackbarInjectionKey } from '~/assets/injection-keys';
import { clearCachedResumeToken } from '~/helpers/local-storage';
import { getVisaCountryByPath } from '~/helpers/visa-country';

const snackbar = inject(snackbarInjectionKey)!;

const route = useRoute();
const hidden = ref(false);

function clearCached() {
  const country = getVisaCountryByPath(route.path);
  if (!country) {
    snackbar.value!.showWarning('No visa country');
    return;
  }
  clearCachedResumeToken(country);
  snackbar.value!.showSuccess('Cached visa form cleared');
}
</script>

<style scoped>
.bar {
  position: fixed;
  bottom: 5%;
  left: var(--space-3);
  z-index: 5;
}
.close {
  position: absolute;
  top: 0;
  right: 0;
}
</style>